import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useModo } from '@providers/modoContext';
import { colors } from '@styles/colors';
import Input from '@components/Input';
import Boton from '@components/Boton';
import { loginUsuarioApi } from '@api/wp/usuarios/usuariosApi';

function Login() {
  const [usuario, setUsuario] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { setModo } = useModo();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!usuario || !clave) {
      setError('Ingresa usuario y clave');
      return;
    }

    try {
      const resp = await loginUsuarioApi({ nombre: usuario, clave });
      const result = resp?.result || resp; // fetchRequest puede devolver directamente el body
      if (!result?.id) {
        setError('Credenciales inválidas');
        return;
      }
      // Guardar token emitido por backend (JWT HS256)
      if (result.token) {
        localStorage.setItem('token', String(result.token));
        if (result.tokenExp) {
          localStorage.setItem('tokenExp', String(result.tokenExp));
        }
      }
      // Sesión activa ya validada en backend (estado = 1)
      localStorage.setItem('loggedIn', 'true');
      localStorage.setItem('usuario', String(result.nombre || usuario));
      localStorage.setItem('idUsu', String(result.id));
      localStorage.setItem('idRol', String(result.idRol || ''));
      // Guardar modo = 1
      setModo(1);
      localStorage.setItem('modo', '1');
      navigate('/administracion/home');
    } catch (err) {
      const msg = err?.message || 'Error al iniciar sesión';
      // Mensajes específicos de backend
      if (msg.includes('Sesión no activa')) {
        setError('Usuario no activo. Contacta al administrador.');
      } else if (msg.includes('Usuario o clave incorrectos')) {
        setError('Usuario o clave incorrectos');
      } else {
        setError('No fue posible iniciar sesión');
      }
    }
  };

  return (
    <div id="principal" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 0,
      padding: 0,
      backgroundImage: 'url(/fondo.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }}>
      <div id="cajLogin" style={{
        width: '49.6vh',
        height: '60.3vh',
        backgroundColor: colors.white,
        border: '1px solid ' + colors.gray200,
        borderRadius: '12px',
        boxShadow: '0 2px 12px ' + colors.tableShadow,
        padding: '2rem',
        marginTop: '1vh',
        alignSelf: 'flex-end',
        marginRight: '40vh',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem'
      }}>
      {/* Logo arriba y centrado */}
      <img
        src="/Logo.svg"
        alt="Logo"
        style={{
          display: 'block',
          width: '20vh',
          height: 'auto',
          margin: '7vh auto'
        }}
      />      
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
          <h2 style={{
            margin: 0,
            fontFamily: 'Inter',
            fontWeight: 700,
            fontSize: '2.2vh',
            color: colors.gray700,
            textAlign: 'center'
          }}>Admin</h2>

          {error && (
            <div style={{
              color: colors.errorText,
              fontFamily: 'Inter',
              fontSize: '1.6vh'
            }}>{error}</div>
          )}

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Input
              placeholder="Usuario"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              ancho="100%"
              nombre="usuario"
            />
          </div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Input
              type="password"
              placeholder="Clave"
              value={clave}
              onChange={(e) => setClave(e.target.value)}
              ancho="100%"
              nombre="clave"
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Boton
              label="Iniciar sesión"
              onClick={handleSubmit}
              color={colors.primary}
              ancho="100%"
              alto="5.3vh"
            />
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
